import cat_img from "./arson_cat.png";
import cat_demo1 from "./arson_cat_demo1.png";
import capybara_img from "./capybara_cappuccino.png";
import capybara_demo1 from "./capybara_cappuccino_demo1.png";
import duck_img from "./chef_duck.png";
import duck_demo1 from "./duck_chef_demo1.png";
import geese_img from "./geese_school_of_business.png";
import geese_demo1 from "./geese_demo1.jpg";
import raccoon_img from "./plant_thief_raccoon.png";
import raccoon_demo1 from "./plant_thief_raccoon_demo1.png";
import raccoon_demo2 from "./plant_thief_raccoon_demo2.jpg";
import puppies_img from "./puppies.png";
import puppies_demo1 from "./puppies_demo1.jpg";
import stoat_img from "./second_stoat_with_a_scarf.png";
import stoat_demo1 from "./stoat_demo1.jpg";
import skillet_img from "./skillet_issue.png";
import skillet_demo1 from "./skillet_issue_demo1.png";
import platypus_img from "./watermelon_platypus.png";
import platypus_demo1 from "./watermelon_platypus_demo1.png";

let all_products = [
  {
    id: 1,
    name: "Arson Cat",
    new_product: false,
    description: "small: 1.25in x 2in | large: 1.75in x 2.75in",
    image: cat_img,
    images: [cat_img, cat_demo1],
    price: {
      Small: "$1.50",
      Medium: "unavailable",
      Large: "$2.00",
    },
  },
  {
    id: 2,
    name: "Capybara Cappuccino",
    new_product: false,
    description: "small: 2in x 1.25in | large: 2.75in x 2.25in",
    image: capybara_img,
    images: [capybara_img, capybara_demo1],
    price: {
      Small: "sold out",
      Medium: "unavailable",
      Large: "$2.00",
    },
  },
  {
    id: 3,
    name: "Duck Chef",
    new_product: false,
    description: "small: 2.25in x 1.25in | large: 3in x 1.75in",
    image: duck_img,
    images: [duck_img, duck_demo1],
    price: {
      Small: "$1.50",
      Medium: "unavailable",
      Large: "$2.00",
    },
  },
  {
    id: 4,
    name: "Geese College of Business",
    new_product: true,
    description: "large: 3in x 2in",
    image: geese_img,
    images: [geese_img, geese_demo1],
    price: {
      Small: "unavailable",
      Medium: "unavailable",
      Large: "$2.00",
    },
  },
  {
    id: 5,
    name: "Plant Thief Raccoon",
    new_product: false,
    description: "medium: 3.5in x 2in | large: 4.5in x 2.5in",
    image: raccoon_img,
    images: [raccoon_img, raccoon_demo1, raccoon_demo2],
    price: {
      Small: "unavailable",
      Medium: "$1.50",
      Large: "$2.00",
    },
  },
  {
    id: 6,
    name: "Puppy Pack",
    new_product: true,
    description: "small: 2.25in x 1.5in",
    image: puppies_img,
    images: [puppies_img, puppies_demo1],
    price: {
      Small: "$4.00",
      Medium: "unavailable",
      Large: "unavailable",
    },
  },
  {
    id: 7,
    name: "Scarf Stoat",
    new_product: true,
    description: "small: 2.5in x 1.75in | large: 3.5in x 2.25in",
    image: stoat_img,
    images: [stoat_img, stoat_demo1],
    price: {
      Small: "$1.50",
      Medium: "unavailable",
      Large: "$2.00",
    },
  },
  {
    id: 8,
    name: "Skillet Issue",
    new_product: false,
    description: "small: 2.25in x 1.25in | large: 3in x 1.75in",
    image: skillet_img,
    images: [skillet_img, skillet_demo1],
    price: {
      Small: "$1.50",
      Medium: "unavailable",
      Large: "$2.00",
    },
  },
  {
    id: 9,
    name: "Watermelon Platypus",
    new_product: false,
    description: "small: 2in x 1.25in | large: 2.75in x 2.75in",
    image: platypus_img,
    images: [platypus_img, platypus_demo1],
    price: {
      Small: "$1.50",
      Medium: "unavailable",
      Large: "$2.00",
    },
  },
];

export default all_products;
